<template>
    <div :class="{ 'widget-panel': isPanel }">
      <div class="loader-container">
        <q-spinner 
          v-show="isLoading" 
          v-if="isLoadingSpinner" 
          size="50px" 
          color="primary"
        />
      </div>
      <div 
        class="widget-chart-container" 
        v-show="!isLoading">
        <slot />
      </div>
    </div>
</template>

<script>
export default {
  props: {
    error: {
      type: undefined
    },

    isError: {
      type: Boolean,
      default: false
    },

    isPanel: {
      type: Boolean,
      default: false
    },

    isLoading: {
      default: false,
      type: Boolean
    },

    isLoadingSpinner: {
      default: true,
      type: Boolean
    }
  }
}
</script>

<style lang="sass">
.widget-panel
  height: 340px
  min-height: 340px

.loader-container
  text-align: center
  transform: translateY(120px)

.widget-chart-container
  height: 100%

.aligner
    display: -webkit-box
    display: -webkit-flex
    display: -ms-flexbox
    display: flex
    -webkit-box-align: center
    -webkit-align-items: center
    -ms-flex-align: center
    align-items: center
    min-height: 290px
    -webkit-box-pack: center
    -webkit-justify-content: center
    -ms-flex-pack: center
    justify-content: center

p.empty-state-margin
  margin: 20px 0px 10px 0px
  color: $ink-light
</style>



// WEBPACK FOOTER //
// DashboardWidget.vue?ab36d1b0